import {useTranslation} from 'react-i18next';
import {Button, SubscriptionCard} from '@tickchak/react-share/live';
import useShow from '../../../hooks/useShow';
import {TMemberSubscription} from './memberTicket.type';
import * as css from './MemberTicket.css';
import MemberTicketHeader from './memberTicketHeader/MemberTicketHeader';
import MemberTicketInfo from './memberTicketInfo/MemberTicketInfo';
import MemberTicketActions from './memberTicketActions/MemberTicketActions';
import MemberTicketsSheet from './memberTicketsSheet/MemberTicketsSheet';
import MemberRedeemSheet from './memberRedeemSheet/MemberRedeemSheet';
import MemberInfoSheet from './memberInfoSheet/MemberInfoSheet';

interface MemberTicketProps {
    subscription: TMemberSubscription;
}

/* The subscription entrance card — one card per series, built on the regular ticket slide */
function MemberTicket({subscription}: MemberTicketProps) {
    const {t} = useTranslation('eTicket');
    const ticketsShow = useShow();
    const redeemShow = useShow();
    const infoShow = useShow();

    return (
        <css.container data-cy="member-ticket">
            <MemberTicketHeader subscription={subscription} />
            <css.cover>
                <SubscriptionCard
                    data-cy="member-subscription-card"
                    item={{
                        qid: subscription.qid,
                        ticketTitle: subscription.title,
                        planType: subscription.planType,
                        ticketColor: subscription.color,
                        coverImage: subscription.image,
                        totalCredits: subscription.totalCredits,
                        usedCredits: subscription.usedCredits
                    }}
                    footerAction={(
                        <Button
                            variant="neutral"
                            size="chip"
                            inverse
                            onClick={infoShow.open}
                            data-cy="member-subscription-info-button">
                            {t('subscriptionDetails')}
                        </Button>
                    )}
                />
            </css.cover>
            <MemberTicketInfo subscription={subscription} />
            <MemberTicketActions subscription={subscription} onMyTickets={ticketsShow.open} onRedeem={redeemShow.open} />
            <MemberTicketsSheet show={ticketsShow} qid={subscription.qid} />
            <MemberRedeemSheet show={redeemShow} qid={subscription.qid} />
            <MemberInfoSheet show={infoShow} subscription={subscription} />
        </css.container>
    );
}

export default MemberTicket;
